enum DateType {
    DAY = 'Day',
    MONTH = 'Month',
    YEAR = 'Year',
    WEEK = 'Week',
}

export default DateType;
